module.exports = __webpack_public_path__ + "img/1440.d19fd6f1.jpg";